<template>
<el-row>
    <el-col>
        <span class="cs-title">课程记录</span>
        <el-row class="hidden-xs-only">
            <el-col :span="18">
                <label> &nbsp; </label>
            </el-col>
        </el-row>
        <el-row class="grid-content">
            <el-col :span="12" :xs="24">
                <el-card class="box-card">
                    <div
                        slot="header"
                        class="clearfix"
                    >
                        <span>大学课程</span> 
                    </div>
                     <teacherSpeedupCourseHistoryList :courseRecords="courseList"></teacherSpeedupCourseHistoryList>
                </el-card>
                 <el-card class="box-card">
                    <div
                        slot="header"
                        class="clearfix"
                    >
                        <span>应试英语课程</span>
                    </div>
                    <teacherSpeedupCourseHistoryList :courseRecords="englishCourseList"></teacherSpeedupCourseHistoryList>
                </el-card>
                <el-card class="box-card">
                    <div
                        slot="header"
                        class="clearfix"
                    >
                        <span>职业培训课程</span>
                    </div>
                    <teacherSpeedupCourseHistoryList :courseRecords="trainingCourseList"></teacherSpeedupCourseHistoryList>
                </el-card>
            </el-col>
        </el-row>
    </el-col>
</el-row>
</template>

<style lang="scss" scoped>
.courses-history-colmun-width {
    min-width: 120px;
}
.course-score-selector{
    height: 30px;
    line-height: 30px;
    width: 100px;
}
.el-card{
    margin-top: 20px;

    &:first-of-type{
        margin-top: 0;
    }
}
</style>

<script>
import teacherSpeedupCourseHistoryList from "./teacherSpeedupCourseHistoryList";


export default {
    props: ["historyList"],
    components:{
        teacherSpeedupCourseHistoryList
    },
    data() {
        return {
          courseList:[],
          englishCourseList:[],
          trainingCourseList:[]
        }
    },
    created() {
       this.initData();
    },
    methods: {    
        initData() {
            if (!!this.historyList){
                this.courseList = this.historyList.filter(i=> i.CourseType == 1);
                this.trainingCourseList = this.historyList.filter(i=> i.CourseType == 3);
                this.englishCourseList = this.historyList.filter(i => i.CourseType == 2);
            }
        },
        
    },
    watch:{
        historyList:function(){
           this.initData();
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/teacherAccount/teacherSpeedupCourseHistory.vue